var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCorporateSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M15.99 11.5c0 3.93-2.638 7.16-5.995 7.5C6.638 18.67 4 15.44 4 11.5S6.657 4.319 10.033 4C13.371 4.36 16 7.58 16 11.51l-.01-.01z",
    fill: "url(#npnyqcgiya)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M6.547 11.448c0-3.413 2.466-6.307 7.232-7.261-.036 0-1.513 0-.096-.01-.096-.011-.169-.053-.265-.084-.144-.02-.3-.03-.445-.052C11.34 4 12.876 4.011 12.84 4c-5.331.705-8.339 3.776-8.339 7.448 0 3.921 2.003 6.145 7.84 6.539.205-.052.41-.114.602-.166-5.14-.788-6.408-2.784-6.408-6.373h.012z",
    fill: "url(#favix2kacb)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.32 20.33 16.5 16.5m2.14-5.18a7.32 7.32 0 1 1-14.64 0 7.32 7.32 0 0 1 14.64 0z",
    stroke: "url(#q0y5gnamvc)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "npnyqcgiya",
    x1: 12.904,
    y1: 27.036,
    x2: 0.057,
    y2: 23.011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#344047"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9A87A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "favix2kacb",
    x1: 11.386,
    y1: 25.48,
    x2: 1.167,
    y2: 22.826,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#344047"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9A87A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "q0y5gnamvc",
    x1: 16.11,
    y1: 29.078,
    x2: -0.528,
    y2: 22.566,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#344047"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9A87A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorporateSearch);
export default __webpack_public_path__ + "static/media/corporateSearch.1b7b6905118fcb9b6ce1ecb7890223a0.svg";
export { ForwardRef as ReactComponent };